export default {
    // 默认网站标题
    title: "上海教育科研",
    // 默认路由地址
    basePath: "/",
    // 接口地址前缀
    apiBaseUrl: "http://webapi.shesr.shuzhiyun.cn/mweb",
	//apiBaseUrl: "https://localhost:44363/mweb",
    // apiBaseUrl: "https://localhost:44393/agent/",
    //socket地址前缀
    socketBaseUrl: "http://webapi.shesr.shuzhiyun.cn/authhub",
	//socketBaseUrl: "https://localhost:44363/authhub",
    // socketBaseUrl: "https://localhost:44393/msgHub",
    // 图片地址前缀
    picUrl: "https://file.shesr.shuzhiyun.cn/img/",
    fileUrl: "https://file.shesr.shuzhiyun.cn/file/",
};